// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table[data-v-8f953bb0]{width:100%}tr.added[data-v-8f953bb0]{background-color:#9e9}tr.removed[data-v-8f953bb0]{background-color:#e99}`, "",{"version":3,"sources":["<input css 2>"],"names":[],"mappings":"AAAA,uBAAM,UAAU,CAAC,0BAAS,qBAAqB,CAAC,4BAAW,qBAAqB","sourcesContent":["table{width:100%}tr.added{background-color:#9e9}tr.removed{background-color:#e99}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
